var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-col', [_c('v-row', [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "480",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("타이틀 텍스트 설정")]), _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', {
    staticClass: "py-3"
  }, [_vm.setting ? [_c('v-text-field', {
    model: {
      value: _vm.setting.startup.title,
      callback: function callback($$v) {
        _vm.$set(_vm.setting.startup, "title", $$v);
      },
      expression: "setting.startup.title"
    }
  })] : _vm._e()], 2), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1)], 1)], 1)], 1)], 1), _c('v-col', [_c('v-row', [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "480",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("카테고리 설정")]), _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', {
    staticClass: "py-3"
  }, [_vm.setting ? [_c('v-combobox', {
    attrs: {
      "multiple": "",
      "chips": "",
      "hide-details": "",
      "outlined": "",
      "append-icon": ""
    },
    model: {
      value: _vm.setting.startup.categories,
      callback: function callback($$v) {
        _vm.$set(_vm.setting.startup, "categories", $$v);
      },
      expression: "setting.startup.categories"
    }
  })] : [_c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  })]], 2), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1)], 1)], 1), _c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "480",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("해시태그 설정")]), _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', {
    staticClass: "py-3"
  }, [_vm.setting ? [_c('v-combobox', {
    attrs: {
      "multiple": "",
      "chips": "",
      "hide-details": "",
      "outlined": "",
      "append-icon": ""
    },
    model: {
      value: _vm.setting.startup.hashTags,
      callback: function callback($$v) {
        _vm.$set(_vm.setting.startup, "hashTags", $$v);
      },
      expression: "setting.startup.hashTags"
    }
  })] : [_c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  })]], 2), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }